import { render } from "./HelloWorld.vue?vue&type=template&id=4f7cb960"
const script = {}

import exportComponent from "C:\\Accent\\Vue_Projects\\NEWWEBECOM_OCT6_2026\\Accent-MIO\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__